import React from 'react'
import ProjectLayout from '../../components/projectLayout'
import data from '../../content/projects/www722IdProject'

export default function WWW722IdProject() {
  return <ProjectLayout data={data} />
}
